import { render, staticRenderFns } from "./cheap.vue?vue&type=template&id=4ab31f99&scoped=true"
import script from "./cheap.vue?vue&type=script&lang=js"
export * from "./cheap.vue?vue&type=script&lang=js"
import style0 from "./cheap.vue?vue&type=style&index=0&id=4ab31f99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab31f99",
  null
  
)

export default component.exports